import React from "react";
import "./ui.css";
// Reuses the ONE existing status/priority color mapping (never
// reimplemented here) -- see src/pages/tasks/StatusChips.jsx, already the
// canonical source for completed=green/in_progress=blue/pending=amber/
// cancelled=red across the portal.
import { statusPillClass, priorityPillClass } from "../../pages/tasks/StatusChips";

const titleCase = (v) => String(v || "-").replace(/_/g, " ").replace(/\w\S*/g, (t) => t.charAt(0).toUpperCase() + t.slice(1).toLowerCase());

// statusPillClass/priorityPillClass return "tlp-pill tlp-pill-<tone>" --
// pull just the tone (green/blue/amber/red/gray) so this component can
// render it with the ui-badge-* classes instead of duplicating the
// status -> color decision.
function toneFromPillClass(pillClass) {
  const match = /tlp-pill-(\w+)/.exec(pillClass || "");
  return match ? match[1] : "gray";
}

export function StatusBadge({ status }) {
  const tone = toneFromPillClass(statusPillClass(status));
  return <span className={`ui-badge ui-badge-${tone}`}>{titleCase(status)}</span>;
}

export function PriorityBadge({ priority }) {
  if (!priority) return <span className="text-muted small">—</span>;
  const tone = toneFromPillClass(priorityPillClass(priority));
  return <span className={`ui-badge ui-badge-${tone}`}>{titleCase(priority)}</span>;
}
